import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/context/useAuth';
import { getStaffByAuthUid, STAFF_QUERY_KEY } from '@/services/firestore/staff';

const tenMinutes = 10 * 60 * 1000;

export function useCurrentStaff() {
  const { user, isAuthenticated } = useAuth();

  return useQuery({
    queryKey: [...STAFF_QUERY_KEY, 'current', user?.uid],
    queryFn: () => getStaffByAuthUid(user!.uid, user!.email),
    enabled: isAuthenticated && Boolean(user?.uid),
    staleTime: tenMinutes,
  });
}
